module.exports = __webpack_public_path__ + "static/media/bananagBoat.00abd8f0.jpg";